"use strict";
exports.__esModule = true;
var ApiClient = /** @class */ (function () {
    function ApiClient(params) {
        if (!params.host) {
            throw new Error('Host is required');
        }
        this.host = params.host;
        this.versionPrefix = params.prefix;
        this.onUnauthorized = params.onUnauthorized;
        this.JWT = params.JWTStorage;
    }
    ApiClient.prototype.post = function (url, params) {
        return this.send('POST', url, params);
    };
    ApiClient.prototype.put = function (url, params) {
        return this.send('PUT', url, params);
    };
    ApiClient.prototype.get = function (url, params) {
        return this.send('GET', url, params);
    };
    ApiClient.prototype["delete"] = function (url, params) {
        return this.send('DELETE', url, params);
    };
    ApiClient.prototype.getApiUrl = function (url) {
        return this.host + this.versionPrefix + url;
    };
    ApiClient.prototype.getJWT = function () {
        return (this.JWT && this.JWT.get()) || null;
    };
    ApiClient.prototype.send = function (method, url, params) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            url = _this.getApiUrl(url);
            var transport = new XMLHttpRequest();
            transport.open(method, url);
            transport.setRequestHeader('Content-Type', 'application/json');
            if (params.headers) {
                params.headers.forEach(function (header) { return transport.setRequestHeader.apply(transport, header); });
                delete params.headers;
            }
            transport.withCredentials = true;
            if (_this.JWT && _this.JWT.get()) {
                transport.setRequestHeader('Authorization', "Bearer " + _this.JWT.get());
            }
            // FIXME: the event is fired when a resource and its dependent resources have finished loading.
            // Use onloadend or onreadystatechange
            transport.onload = function () {
                if (transport.status === 401) {
                    if (_this.onUnauthorized) {
                        _this.onUnauthorized();
                    }
                }
                if (transport.status >= 200 && transport.status < 300 /* 🚜 */) {
                    resolve(JSON.parse(transport.responseText));
                }
                else {
                    reject(transport);
                }
            };
            transport.onerror = function () {
                reject(transport);
            };
            transport.send(JSON.stringify(params));
        });
    };
    return ApiClient;
}());
exports["default"] = ApiClient;
